import * as React from "react";
import { notificationTypes } from "modules/common";
import { useContext, useMemo } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    notificationType: string[];
}

export const Notifications: React.FC<Props> = ({ notificationType }) => {
    const notifications = useMemo(
        () => [
            {
                value: notificationTypes.Email.value,
                label: notificationTypes.Email.label,
            },
            {
                value: notificationTypes.Application.value,
                label: notificationTypes.Application.label,
            },
        ],
        []
    );
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <div className="notification-container">
            {notifications
                .filter(n => notificationType.includes(n.label))
                .map(({ label, value }) => (
                    <div key={value}>
                        <label
                            className={lowVision ? " low-vision-white-text" : "notification-text"}
                        >
                            {label}
                        </label>
                    </div>
                ))}
        </div>
    );
};
